/**
 * Hook for LS Quick Pay button
 */
import { useEffect, useState } from 'react'
import { vn } from 'vend-number'
import { useAppSelector } from '../../../state/hooks'

import { getFeatureFromCache } from '../../../util/feature-cache'
import { selectCurrentSale } from '../../../state/slices/currentSale/currentSaleSlice'
import {
  usePaymentManager,
  useTrainingModeManager,
  useWebRegisterStatusManager,
} from '../../../ng-compat/hooks'
import { getOutstandingBalance } from '../../../functions/sale'
import { MINIMUM_LSPAY_AMOUNT } from '../sale-model.constant'
import { useCanTransitionToPaymentScreen } from './sale-payment-button/use-can-transition-to-payment-screen'

export const useLSQuickPay = () => {
  const paymentManager = usePaymentManager()
  const trainingModeManager = useTrainingModeManager()
  const canTransitionToPaymentScreen = useCanTransitionToPaymentScreen()

  const currentSale = useAppSelector(selectCurrentSale)
  const webRegisterStatusManager = useWebRegisterStatusManager()
  const [showQuickPayButton, setShowQuickPayButton] = useState(false)
  const [disableQuickPayButton, setDisableQuickPayButton] = useState(false)

  const trainingModeEnabled = trainingModeManager.trainingModeEnabled

  useEffect(() => {
    const shouldShowQuickPayButton = async () => {
      const hasLspayPaymentType = await paymentManager.hasLspayPaymentType()
      const ffQuickPayEnabled = getFeatureFromCache(
        'lspay_pay_with_quick_pay_experiment'
      )

      const result =
        ffQuickPayEnabled && hasLspayPaymentType && !trainingModeEnabled

      setShowQuickPayButton(result)
    }
    shouldShowQuickPayButton()
  }, [paymentManager, trainingModeEnabled, currentSale])

  useEffect(() => {
    const shouldDisableQuickPayButton = () => {
      const outstandingBalance = getOutstandingBalance(currentSale)
      const isOnline = webRegisterStatusManager.isOnline()
      const disabled =
        !isOnline ||
        vn(outstandingBalance).lte(0) ||
        vn(outstandingBalance).lt(MINIMUM_LSPAY_AMOUNT) ||
        !canTransitionToPaymentScreen

      setDisableQuickPayButton(disabled)
    }
    shouldDisableQuickPayButton()
  }, [canTransitionToPaymentScreen, currentSale, webRegisterStatusManager])

  return { showQuickPayButton, disableQuickPayButton }
}
